import React,{ Component } from "react";
import { connect } from "react-redux";
import UserForm from "../UserForm/UserForm";
import { Row, Col,  Card, CardHeader, Container} from "reactstrap";
import { createUser } from "../../../actions/actionAdminUser";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Users",path:"/adminUser",isActive: false},
    {name: "CreateUser",path:"/createuser",isActive: true},
];

class CreateUser extends Component{
    render(){
        return (
            <div>    
                <BreadCrumbCompo routes={routes}/>  
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className="user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i>  <strong>Create User</strong>
                                </CardHeader>
                                <UserForm
                                    createUser={this.props.createUser}
                                />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}


CreateUser.propTypes = {
    createUser: Proptypes.func.isRequired,
};

export default connect(state => ({
    users: state.admin.users || []
}), 
dispatch => ({
    createUser: (data) => dispatch(createUser(data))
}))(CreateUser);